import { useQuery } from '@tanstack/react-query';
import { ExtractFnReturnType, QueryConfig } from '../../../lib/react-query';
import { fetchApi } from '../../../lib/fetchApi';
import { SurveysHistory } from '../types';
import { SelectedFilter } from '../../../components/Filters/types';
import { useSelector } from 'react-redux';
import { RootState } from '../../../redux/store';

export const getHistory = async (
	selectedFilters: SelectedFilter[],
	pageNumber: number,
	pageSize: number,
	orderByField: string,
	orderDirection: 'asc' | 'desc'
): Promise<SurveysHistory> => {
	const response = await fetchApi.post('/surveys/history', {
		selectedFilters,
		pageNumber,
		pageSize,
		orderByField,
		orderDirection
	}) as SurveysHistory;
	return response;
}

export const deleteSurvey = async (surveyId: number): Promise<void> => {
  	await fetchApi.delete(`/surveys/survey/${surveyId}`);
}

type QueryFnType = typeof getHistory;

type UseHistoryOptions = {
	config?: QueryConfig<QueryFnType>;
	pageNumber?: number;
	orderByField?: string;
	orderDirection?: 'asc' | 'desc';
};

export const useHistory = ({
	config,
	pageNumber = 1,
	orderByField = "",
	orderDirection = 'asc',
}: UseHistoryOptions = {}) => {
	const selectedFilters = useSelector((state: RootState) => state.filters.dashboard.selectedFilters);
	const itemsPerPage = useSelector((state: RootState) => state.historical.historicalData.itemsPerPage);
	
	return useQuery<ExtractFnReturnType<QueryFnType>>({
		...config,
		refetchOnMount: true,
		refetchOnWindowFocus: false,
		queryKey: ["history", selectedFilters, pageNumber, itemsPerPage, orderByField, orderDirection],
		queryFn: () => getHistory(selectedFilters, pageNumber, itemsPerPage, orderByField, orderDirection),
	});
}
